/*
 * Dynamischer Warenkorb-Upsell
 * ---------------------------------------------------------------------------
 * Zeigt im Warenkorb-Drawer und auf der Warenkorb-Seite Produkte an, die zu den
 * Artikeln im Warenkorb passen - statt einer festen Collection.
 *
 * Reihenfolge der Quellen (gestaffelt, wird nacheinander aufgefuellt):
 *   1. "Ergaenzende Produkte" aus Search & Discovery  (intent=complementary)
 *   2. Shopifys automatische Empfehlungen             (intent=related)
 *   3. Die feste Collection aus den Theme-Einstellungen (Notfall-Fallback)
 *
 * Angezeigt wird nach Preis aufsteigend - das guenstigste Produkt steht vorne.
 * Produkte, die bereits im Warenkorb liegen, werden immer herausgefiltert.
 *
 * WICHTIG - warum das hier so umstaendlich aussieht:
 * Ein MutationObserver ueberwacht den Warenkorb. Wuerde dieses Script die Liste
 * bei jedem Durchlauf neu schreiben, loeste es damit den naechsten Durchlauf aus
 * und die Produkte wuerden sichtbar flackern. Deshalb:
 *   - jede Liste merkt sich in data-upsell-render-key, was sie gerade zeigt,
 *     und wird nur angefasst, wenn sich dieser Key aendert
 *   - eigene DOM-Aenderungen laufen in withoutObservers() und werden aus der
 *     Beobachtungs-Queue entfernt
 *   - Mutationen, die innerhalb der Upsell-Bloecke passieren, werden ignoriert
 *   - geklonte Bloecke bekommen ihren Inhalt VOR dem Einhaengen, damit kein
 *     Zwischenstand sichtbar wird
 */
(function () {
  'use strict';

  // Das Script wird an zwei Stellen eingebunden (cart-drawer.liquid und
  // cart-upsell.liquid) - doppelte Ausfuehrung hier abfangen.
  if (window.__grillfreudeCartUpsell) return;
  window.__grillfreudeCartUpsell = true;

  var SECTION_ID = 'cart-upsell-recommendations';
  var MAX_SEED_PRODUCTS = 3; // max. Anzahl Warenkorb-Artikel, fuer die wir Empfehlungen holen
  var API_LIMIT = 10; // max. erlaubtes Limit der Recommendations-API
  var DEBOUNCE_MS = 400;
  var KEY_ATTR = 'data-upsell-render-key';
  var PLACED_CLASS = 'cart-drawer-upsell-block--placed';

  var renderKey = null; // Warenkorb-Signatur, zu der cachedHTML gehoert
  var cachedHTML = null; // gerenderte <li>-Liste; null = noch nichts geladen
  var inFlight = false;
  var refreshQueued = false;
  var mutating = false;
  var debounceTimer = null;
  var observers = [];

  // ---------------------------------------------------------------------------
  // Hilfsfunktionen
  // ---------------------------------------------------------------------------

  function templateBlock() {
    var wrapper = document.getElementById('cart-drawer-upsell-wrapper');
    return wrapper ? wrapper.querySelector('.cart-drawer-upsell-block') : null;
  }

  function templateList() {
    var template = templateBlock();
    return template ? template.querySelector('.cart-drawer-upsell-list') : null;
  }

  function placedBlocks() {
    return Array.prototype.slice.call(document.querySelectorAll('.' + PLACED_CLASS));
  }

  function cartUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function recommendationsUrl() {
    var list = templateList();
    var fromData = list && list.getAttribute('data-recommendations-url');
    return (
      fromData ||
      (window.routes && window.routes.product_recommendations_url) ||
      '/recommendations/products'
    );
  }

  function displayLimit() {
    var list = templateList();
    var value = list ? parseInt(list.getAttribute('data-limit'), 10) : NaN;
    if (isNaN(value) || value < 1) value = 8;
    return Math.min(value, 12);
  }

  // Fuehrt eigene DOM-Aenderungen aus, ohne die eigenen Beobachter auszuloesen.
  function withoutObservers(fn) {
    mutating = true;
    try {
      fn();
    } finally {
      observers.forEach(function (observer) {
        observer.takeRecords();
      });
      mutating = false;
    }
  }

  // ---------------------------------------------------------------------------
  // Inhalt setzen (nur wenn er sich wirklich geaendert hat)
  // ---------------------------------------------------------------------------

  function applyToBlock(block) {
    if (cachedHTML === null) return; // noch nichts geladen -> Fallback stehen lassen

    var list = block.querySelector('.cart-drawer-upsell-list');
    if (!list) return;
    if (list.getAttribute(KEY_ATTR) === renderKey) return; // schon aktuell

    list.innerHTML = cachedHTML;
    list.setAttribute(KEY_ATTR, renderKey);
    block.hidden = cachedHTML === '';
  }

  function applyToAll() {
    placedBlocks().forEach(applyToBlock);
  }

  function cloneBlock() {
    var template = templateBlock();
    if (!template) return null;

    var clone = template.cloneNode(true);
    clone.removeAttribute('id');
    clone.classList.add(PLACED_CLASS);
    applyToBlock(clone); // Inhalt setzen, solange der Block noch nicht im DOM haengt
    return clone;
  }

  // ---------------------------------------------------------------------------
  // Platzierung (idempotent - kann jederzeit erneut aufgerufen werden)
  // ---------------------------------------------------------------------------

  function placeInDrawer() {
    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;
    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.classList.add('cart-drawer-items-wrapper');
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
      wrapper.appendChild(cartDrawerItems);
    }

    if (wrapper.querySelector('.' + PLACED_CLASS)) return;

    var block = cloneBlock();
    if (!block) return;
    block.classList.add('cart-drawer-upsell-block--drawer');
    wrapper.appendChild(block);
  }

  function placeInCartPage() {
    var cartItems = document.querySelector('#MainContent cart-items');
    if (!cartItems) return;
    if (cartItems.classList.contains('is-empty')) return;

    var host = cartItems.querySelector('.page-width') || cartItems;
    if (host.querySelector('.' + PLACED_CLASS)) return;

    var block = cloneBlock();
    if (!block) return;
    block.classList.add('cart-drawer-upsell-block--page');
    host.appendChild(block);
  }

  function syncDom() {
    withoutObservers(function () {
      placeInDrawer();
      placeInCartPage();
      applyToAll();
    });
  }

  function removeAll() {
    withoutObservers(function () {
      placedBlocks().forEach(function (block) {
        if (block.parentNode) block.parentNode.removeChild(block);
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Daten holen
  // ---------------------------------------------------------------------------

  function fetchCart() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      return res.json();
    });
  }

  function fetchRecommendations(productId, intent) {
    var url =
      recommendationsUrl() +
      '?section_id=' +
      encodeURIComponent(SECTION_ID) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      API_LIMIT +
      '&intent=' +
      encodeURIComponent(intent);

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations fetch failed');
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-upsell-product-id]'));
      })
      .catch(function () {
        return [];
      });
  }

  // ---------------------------------------------------------------------------
  // Auswahl
  // ---------------------------------------------------------------------------

  // Nimmt abwechselnd aus jeder Gruppe (Round Robin), damit nicht ein einziges
  // Warenkorb-Produkt die gesamte Liste belegt.
  function interleave(groups, taken, limit) {
    var picked = [];
    var maxLength = groups.reduce(function (max, group) {
      return Math.max(max, group.length);
    }, 0);

    for (var i = 0; i < maxLength && picked.length < limit; i++) {
      for (var g = 0; g < groups.length && picked.length < limit; g++) {
        var item = groups[g][i];
        if (!item) continue;
        var id = item.getAttribute('data-upsell-product-id');
        if (!id || taken.indexOf(id) !== -1) continue;
        taken.push(id);
        picked.push(item);
      }
    }
    return picked;
  }

  function fallbackItems(taken, limit) {
    var template = templateBlock();
    if (!template) return [];

    var picked = [];
    var items = template.querySelectorAll('li[data-upsell-product-id]');
    for (var i = 0; i < items.length && picked.length < limit; i++) {
      var id = items[i].getAttribute('data-upsell-product-id');
      if (!id || taken.indexOf(id) !== -1) continue;
      taken.push(id);
      picked.push(items[i].cloneNode(true));
    }
    return picked;
  }

  // Anzeigereihenfolge: guenstigstes Produkt zuerst.
  function sortByPriceAsc(items) {
    return items.slice().sort(function (a, b) {
      var priceA = parseInt(a.getAttribute('data-upsell-price'), 10);
      var priceB = parseInt(b.getAttribute('data-upsell-price'), 10);
      if (isNaN(priceA)) priceA = Number.MAX_SAFE_INTEGER;
      if (isNaN(priceB)) priceB = Number.MAX_SAFE_INTEGER;
      return priceA - priceB;
    });
  }

  // Fuer welche Warenkorb-Artikel holen wir Empfehlungen? Teuerster zuerst,
  // damit das Zubehoer zum Hauptgeraet die Plaetze bekommt. Die Anzeige wird
  // danach ohnehin nach Preis aufsteigend sortiert.
  function seedProductIds(cart) {
    var sorted = cart.items.slice().sort(function (a, b) {
      return (b.price || 0) - (a.price || 0);
    });
    var ids = [];
    sorted.forEach(function (item) {
      var id = String(item.product_id);
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.slice(0, MAX_SEED_PRODUCTS);
  }

  function loadRecommendations(cart) {
    var limit = displayLimit();
    var seeds = seedProductIds(cart);
    var taken = cart.items.map(function (item) {
      return String(item.product_id);
    });

    if (!seeds.length) return Promise.resolve([]);

    return Promise.all(
      seeds.map(function (id) {
        return fetchRecommendations(id, 'complementary');
      })
    )
      .then(function (groups) {
        var picked = interleave(groups, taken, limit);
        if (picked.length >= limit) return picked;

        return Promise.all(
          seeds.map(function (id) {
            return fetchRecommendations(id, 'related');
          })
        ).then(function (relatedGroups) {
          return picked.concat(interleave(relatedGroups, taken, limit - picked.length));
        });
      })
      .then(function (picked) {
        if (picked.length < limit) {
          picked = picked.concat(fallbackItems(taken, limit - picked.length));
        }
        return sortByPriceAsc(picked);
      });
  }

  // ---------------------------------------------------------------------------
  // Ablauf
  // ---------------------------------------------------------------------------

  function finish() {
    inFlight = false;
    if (refreshQueued) {
      refreshQueued = false;
      scheduleRefresh();
    }
  }

  function refresh() {
    if (!templateBlock()) return;
    if (inFlight) {
      refreshQueued = true;
      return;
    }
    inFlight = true;

    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          renderKey = null;
          cachedHTML = null;
          removeAll();
          return null;
        }

        var signature = cart.items
          .map(function (item) {
            return item.product_id;
          })
          .sort()
          .join(',');

        // Gleicher Warenkorb wie beim letzten Mal: nichts nachladen, nur
        // sicherstellen, dass die Bloecke an Ort und Stelle sind.
        if (signature === renderKey && cachedHTML !== null) {
          syncDom();
          return null;
        }

        return loadRecommendations(cart).then(function (items) {
          return { signature: signature, items: items };
        });
      })
      .then(function (result) {
        if (!result) return;

        cachedHTML = result.items
          .map(function (item) {
            return item.outerHTML;
          })
          .join('');
        renderKey = result.signature;
        syncDom();
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[cart-upsell]', error);
        syncDom(); // im Fehlerfall bleibt der Collection-Fallback stehen
      })
      .then(finish, finish);
  }

  function scheduleRefresh() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, DEBOUNCE_MS);
  }

  // ---------------------------------------------------------------------------
  // Variantenwechsel in der Upsell-Karte -> Bild tauschen
  // ---------------------------------------------------------------------------

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    var option = select.options[select.selectedIndex];
    var imgSrc = option && option.dataset ? option.dataset.variantImg : null;
    if (!imgSrc) return;

    var item = select.closest('.cart-drawer-upsell-list-item');
    var img = item && item.querySelector('.cart-drawer-upsell-list-item-left img');
    if (img) img.src = imgSrc;
  };

  // ---------------------------------------------------------------------------
  // Beobachter
  // ---------------------------------------------------------------------------

  function isInsideUpsell(node) {
    var element = node && node.nodeType === 1 ? node : node && node.parentNode;
    return !!(element && element.closest && element.closest('.' + PLACED_CLASS));
  }

  function handleMutations(mutations) {
    if (mutating) return;

    // Aenderungen innerhalb der Upsell-Bloecke ignorieren - sonst reagiert das
    // Script auf sich selbst und die Liste flackert.
    var relevant = mutations.some(function (mutation) {
      return !isInsideUpsell(mutation.target);
    });
    if (!relevant) return;

    scheduleRefresh();
  }

  function observe(element) {
    if (!element) return;
    var observer = new MutationObserver(handleMutations);
    observer.observe(element, { attributes: true, childList: true, subtree: true });
    observers.push(observer);
  }

  function init() {
    refresh();
    observe(document.querySelector('cart-drawer'));
    observe(document.querySelector('#MainContent cart-items'));
    document.addEventListener('cart:refresh', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
